<template>
	<b-button :variant="variant" @click="$emit('click')" class="save__btn">
		<font-awesome-icon icon="save" />
		{{ $t(label) }}
	</b-button>
</template>
<script>
	export default {
		name: 'button-save',
		props: {
			label: {
				type: String,
				required: false,
				default: () => 'save',
			},
			variant: {
				type: String,
				default: () => 'primary',
			},
		},
	}
</script>

<style lang="scss" scoped>
	.save__btn {
		position: fixed;
		border-radius: 500px;
		bottom: 0.5rem;
		right: 0.5rem;
		width: fit-content;
		min-width: 6.5rem;
		align-items: center;
		justify-content: center;
	}
</style>
